module.exports = __webpack_public_path__ + "static/media/01.21a9e19d.png-rocket";